<template>
    <div class="space-y-2 md:pl-6">
        <div class="relative md:-ml-3">
            <div
                class="absolute inset-0 flex items-center"
                aria-hidden="true"
            >
                <div class="w-full border-t border-gray-300" />
            </div>
            <div class="relative flex justify-start pl-6">
                <span
                    class="bg-white px-3 text-lg font-medium leading-6 text-gray-900"
                >
                    <span
                        v-if="required"
                        class="text-red-600"
                    >
                        *
                    </span>
                    {{ attachmentRequirement.attachmentTypeName }}
                </span>
            </div>
        </div>

        <content-reset :body="constraintConfig.message" />

        <div
            v-if="attachmentRequirement.attachmentResult !== null"
            class="flex gap-12"
        >
            <div>
                <div class="text-lg">
                    Attachment:
                    <span class="font-semibold">{{
                        attachmentRequirement.attachmentResult.title
                    }}</span>
                </div>
                <div
                    v-if="attachmentRequirement.attachmentResult.valid === null"
                    class="text-sm font-medium italic text-gray-500"
                >
                    PENDING UPLOAD
                </div>
                <div
                    v-else-if="!attachmentRequirement.attachmentResult.valid"
                    class="text-red-600 text-sm font-medium italic"
                >
                    PENDING STAFF VALIDATION
                </div>
                <div
                    v-if="
                        attachmentRequirement.attachmentResult.valid &&
                        attachmentRequirement.attachmentResult.expiresAt !==
                            null
                    "
                >
                    Expires:
                    {{
                        formatTimelessDate(
                            parseTimeless(
                                attachmentRequirement.attachmentResult.expiresAt
                            )
                        )
                    }}
                </div>
            </div>

            <div class="flex">
                <attachment-uploader
                    choose-label="Replace"
                    :choose-button-props="{ severity: 'danger' }"
                    @file="
                        attachmentRequirement.attachmentResult.valid === null
                            ? $emit('replace', $event)
                            : $emit('file', $event)
                    "
                />
            </div>
        </div>

        <div
            v-else
            class="flex"
        >
            <attachment-uploader
                :choose-button-props="{ severity: 'danger' }"
                @file="$emit('file', $event)"
            />
        </div>

        <div
            v-if="
                showErrors &&
                required &&
                attachmentRequirement.attachmentResult === null
            "
            class="text-red-600"
        >
            Please upload a valid file above.
        </div>
    </div>
</template>

<script setup lang="ts">
import type { AttachmentRequirement } from '~/components/PurchaseContract/ParticipantDetails/enrollment-constraint'
import {
    formatTimelessDate,
    parseTimeless
} from '~/composables/support/localization'
import AttachmentUploader from '~/components/Attachment/AttachmentUploader.vue'
import ContentReset from '~/components/ContentReset.vue'
import { computed } from 'vue'
import { useLayoutMode } from '~/composables/use-layout-mode'

const props = defineProps<{
    attachmentRequirement: AttachmentRequirement
    constraintConfig: {
        required: boolean
        message: string
    }
    showErrors: boolean
}>()

defineEmits<{
    (e: 'file', payload: File): true
    (e: 'replace', payload: File): true
}>()

const { isKiosk } = useLayoutMode()
const required = computed(() => {
    return isKiosk.value ? false : props.constraintConfig.required
})
</script>
